module.exports = __webpack_public_path__ + "static/media/logo.e22b8bad.png";